import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { departmentOptionActions } from './department-option.actions';
import { departmentOptionSelectors } from './department-option.reducer';

@Injectable({ providedIn: 'root' })
export class DepartmentOptionEffects {
   defaultFields: string[] = ['name', 'departmentId', 'isActive', 'accountId'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      departmentOptionSelectors.selectState,
      'departments?SerializeEnumsAsStrings=true',
      this.defaultFields,
      this.defaultOrderingOptions,
      departmentOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>, private store: Store) {}
}
